/**
 * Public numeric claims shown across the marketing site. The live value is a
 * service key (SettingKey.PUBLIC_LEAK_SITES_COUNT) a manager edits in
 * /admin/settings; this constant is only the fallback when the setting is blank
 * or the API cannot be reached. See docs/product-knowledge-base.md.
 */

/** Fallback for how many known leak sites we search, if the setting is unset. */
export const DEFAULT_LEAK_SITES_COUNT = '100,000+';
